import dayjs from 'dayjs';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/elements/Button';
import Card from '../../components/elements/Card';
import DataTable from '../../components/elements/DataTable';
import ErrorHandler from '../../components/elements/ErrorHandler';
import LoadingBars from '../../components/elements/LoadingBars/LoadingBars';
import ScrollToTop from '../../components/elements/ScrollToTop';
import Text from '../../components/fields/Text';
import ModalError from '../../components/fragments/ModalError/ModalError';
import SinkronisasiFilter from '../../components/fragments/SinkronisasiFilter/SinkronisasiFilter';
import { AppContext, ToastrContext } from '../../contexts';
import { thousand } from '../../utils/format';
import { useDebounce } from '../../utils/hooks';
import { fetchDownloadLogs, fetchLogSyncMerchant } from './actions';
import styles from './styles.scoped.css';
import ModalSetPassword from '../../components/fragments/ModalSetPassword';

function SinkronisasiMerchant() {
  const { setBreadcrumbs } = useContext(AppContext);
  const { setToastr } = useContext(ToastrContext);
  const [modalSetPassword, setModalSetPassword] = useState(false);
  const dispatch = useDispatch();
  const {
    data, loading, filter, meta, message, success
  } = useSelector((state) => state.logsSyncMerchant.table);
  const {
    loading: isLoadingDownload,
    data: dataDownload,
    success: successDownload,
  } = useSelector((state) => state.logsSyncMerchant.download);

  const inputRef = useRef(null);
  const ref = useRef(true);

  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [modalOutRangeVisible, setModalOutRangeVisible] = useState(false);
  const debouncedSearch = useDebounce(search, 1000);

  useEffect(() => {
    setBreadcrumbs(['Log Sinkronisasi Data Pangkalan']);
  }, []);

  useEffect(() => {
    dispatch(fetchLogSyncMerchant(debouncedSearch, filter, 1, true));
  }, [debouncedSearch, filter]);

  const column = [
    {
      heading: 'ID Pangkalan',
      value: 'registrationId',
      className: styles['id-registrasi'],
    },
    {
      heading: 'Tanggal',
      value: 'date',
    },
    {
      heading: 'Pukul',
      value: 'time',
    },
    {
      heading: 'Nama Pangkalan LPG 3 Kg',
      value: 'storeName',
      className: styles['store-name'],
    },
    {
      heading: 'Alasan',
      className: styles['reason'],
      value: (val) => val?.reason.map((reason) => <li key={reason}>{reason}</li>),
    },
    {
      heading: 'Status',
      value: (val) => renderStatus(val),
      className: styles['status-coloumn'],
    },
    {
      heading: 'Action',
      value: (val) => renderActions(val),
      className: '',
    },
  ];

  const renderStatus = (data) => {
    return (
      <div className={styles['status-container']}>
        <span>{data.status}</span>
      </div>
    );
  };
  const renderActions = (data) => {
    const { id } = data;
    return (
      <Button className={styles.btnDetail} onClick={() => handledDetail(id)}>
        Rincian
      </Button>
    );
  };

  useEffect(() => {
    if (successDownload && !isLoadingDownload && !ref.current) {
      setToastr({
        desc: 'Berhasil set kata sandi pada file yang akan diunduh.',
        type: 'success',
        visible: true,
      });

      setModalSetPassword(false);

      setTimeout(() => {
        let a = document.createElement('a');
        a.href = dataDownload?.fileUrl;
        a.click();
        ref.current = true;
      }, 1000);
    }
  }, [dataDownload, isLoadingDownload]);


  const handledDetail = (id) => {
    navigate(`/merchant/sinkronisasi-merchant/${id}`);
  };

  const handleDownload = (val) => {
    ref.current = false;
    dispatch(fetchDownloadLogs(filter, debouncedSearch, val.password));
  };
  const onClickDownload = () => {
    const date1 = dayjs(filter.startDate);
    const date2 = dayjs(filter.endDate);
    const diff = date2.diff(date1, 'day');

    if (diff <= 31) setModalSetPassword(true);
    else setModalOutRangeVisible(true);
  };

  if (message && !success) {
    return <ErrorHandler message={message} />;
  }

  return (
    <main className={styles.root}>
      <SinkronisasiFilter />
      <Card className={styles['table-filter-container']}>
        <div className={styles.rightContainer}>
          <Button
            className={styles['btn-download']}
            disabled={isLoadingDownload}
            onClick={onClickDownload}>
            {isLoadingDownload ?
              <LoadingBars className={styles['loading-bars']} size={1} />
              : <img src="assets/ic-download.svg" />}
            Unduh Data
          </Button>
          <p>
            Menampilkan <strong>{thousand(meta.totalData)}</strong> data
          </p>
        </div>
        <div className={styles['filter-wrap']}>
          <div className={styles.filters}>
            <Text
              className={styles['search-bar']}
              disabled={loading}
              hideLabel
              inputProps={{
                ref: inputRef,
                placeholder: 'Cari ID Pangkalan...',
                value: search,
                icon: 'ic-search.svg',
                onChange: (e) => {
                  setSearch(e.target.value);
                }
              }}
            />
          </div>
        </div>
      </Card>
      <Card className={styles.table}>
        <div className={styles['table-container']} >
          <DataTable
            className={styles.table}
            column={column}
            data={data}
            endTreshould={500}
            loading={loading}
            meta={meta}
            onEndReached={() => {
              !loading && dispatch(fetchLogSyncMerchant(debouncedSearch, filter, meta.page + 1));
            }
            }
            withIndex />
        </div>
      </Card>

      <ModalError
        open={modalOutRangeVisible}
        setModalError={setModalOutRangeVisible} />
      <ModalSetPassword
        handledClose={() => setModalSetPassword(false)}
        handledDownload={handleDownload}
        isLoading={isLoadingDownload}
        open={modalSetPassword}
      />

      <ScrollToTop />
    </main>
  );
}

export default SinkronisasiMerchant;
